import React, { useEffect, useState, useRef } from "react";
import { Flex, Text, Box, Input, Textarea, Button } from "@chakra-ui/react";
import './MessagesCSS.css';
import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'


const Messages = ({ messages, loading, bot_id, showThreeDots, userMessageColor, botMessageColor, backgroundColor, testBot }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [msgLoading, setMsgLoading] = useState(false);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  function LinkRenderer(props) {
    console.log({ props });
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

  const pickTextColorBasedOnBgColorSimple = (bgColor, lightColor, darkColor) => {
    console.log("PICKING COLOR", bgColor, lightColor, darkColor)
    var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    const colorValue = (r * 0.299) + (g * 0.587) + (b * 0.114);
    console.log("Color Value", colorValue)
    console.log("chosen color", colorValue > 190 ? darkColor : lightColor)
    return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 190) ?
      darkColor : lightColor;
  }
  

  const messagesContainerRef = useRef();

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  useEffect(() => {
    // Scroll to the bottom of the container with smooth scrolling
    messagesContainerRef.current.scrollTo({
      top: messagesContainerRef.current.scrollHeight,
      behavior: 'smooth',
    });
  }, [messages]);


  const handleSubmit = async () => {
    setMsgLoading(true);
    if (!name.trim().length || !email.trim().length || !message.trim().length) {
      setError("Please fill out all fields");
      setMsgLoading(false);
      return;
    }

    try {
      //send a post request to the backend with the name, email, and message
      const response = await fetch(`${process.env.REACT_APP_API_URL}/publicbot/message/` + bot_id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          message,
          bot_id
        }),
      });
    } catch (error) {
      setMsgLoading(false);
      console.log(error);
      setError("An error occured, please try again")
    } finally {
      setMsgLoading(false);
      setName("")
      setEmail("")
      setMessage("")
      setError("Your message has been sent!")
    }
      
  };



  return (
    <Flex w="100%" h="100%" overflowY="auto" flexDirection="column" p = "3" ref={messagesContainerRef}  bgColor={testBot ? undefined : backgroundColor || "#FFFFFF"}>
      
      {messages.map((item, index) => {
        if (item.from === "me") {
          return (
            <Flex key={index} w="100%" justify="flex-end">
              <Flex
                bg = {userMessageColor ? userMessageColor : "gray.500"}
                color = {userMessageColor ? pickTextColorBasedOnBgColorSimple(userMessageColor ? userMessageColor : 'gray.500', '#FFFFFF', '#000000') : '#FFFFFF'}
                maxW="700px"
                my="1"
                p="3"
                borderRadius="md"
              >
                <Text>{item.text}</Text>
              </Flex>
            </Flex>
          );
        } else if (item.from === "contact") {
          return (
            <Flex pt = "3" w = "100%">
              <Box
                borderColor = "gray.400"
                borderWidth="2px"
                borderRadius="lg"
                p={6}
                width={{ base: '90%', sm: '80%', md: '50%' }}
              >
                <Input
                  placeholder="Name"
                  mb={4}
                  value={name}
                  onChange={handleNameChange}
                />
                <Input
                  placeholder="Email"
                  mb={4}
                  value={email}
                  onChange={handleEmailChange}
                />
                <Textarea
                  placeholder="Message"
                  resize="vertical"
                  mb={4}
                  value={message}
                  onChange={handleMessageChange}
                />
                <Button isLoading = {msgLoading} onClick = {handleSubmit} colorScheme="black" backgroundColor="black" color="white">
                  Send Message
                </Button>
                <Text>{error}</Text>
              </Box>
          </Flex>
          )
        } else {
          return (
            <Flex key={index} w="100%"> 
              <Flex
                borderRadius="md"
                bg= {botMessageColor ? botMessageColor : "gray.300"}
                maxW="700px"
                my="1"
                p="3"
                color = {botMessageColor ? pickTextColorBasedOnBgColorSimple(botMessageColor ? botMessageColor : 'gray.300', '#FFFFFF', '#000000') : '#000000'}
                sx={{
                  a: {
                    color: 'blue', // Sets the text color to blue
                    textDecoration: 'underline', // Adds an underline to the text
                  },
                  ul: {
                    listStylePosition: 'inside', // Ensures bullet points are inside the container
                    margin: 0, // Removes default margin
                    padding: 0, // Adjust padding as needed, or remove it
                  },
                  ol: {
                    listStylePosition: 'inside', // Ensures numbers are inside the container
                    margin: 0, // Removes default margin
                    padding: 0, // Adjust padding as needed, or remove it
                  },
                  // You might also want to style 'li' elements for further adjustments
                  li: {
                    // Add styles for list items if needed
                  },
                }}
                flexDir = "column"
              >
                 <ReactMarkdown
                    children={item.text}
                    components={{ a: LinkRenderer }}
                  />
              </Flex>
            </Flex>
          );
        }
      })}
        {showThreeDots && (
        <div className="half light ">
          <div className="typing">
            <span className="circle bouncing"></span>
            <span className="circle bouncing"></span>
            <span className="circle bouncing"></span>
          </div>
          <br />
        </div>
        )}
    </Flex>
  );
};

export default Messages;
